module.exports = __webpack_public_path__ + "img/EN.0a7c8d5d.png";